<template>
    <span style="color:#9E9E9E;">
        <span v-if="value === 0" style="color:#FF8A80;">待处理</span>
        <span v-if="value === 2" style="color:#FB8C00;">处理中</span>
        <span v-if="value === 4" style="color:#67C23A;">已完成</span>
    </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
.us-priority-0{
  background-color: #409EFF;
  color: #fff !important;
  min-width: 2rem;
  text-align: center;
  padding: 0.3rem 0.5rem;
  padding-bottom: 0.2rem;
  border-radius: 0.2rem;
}
.us-priority-1{
  background-color: #FF9900;
  color: #fff !important;
  min-width: 2rem;
  text-align: center;
  padding: 0.3rem 0.5rem;
  padding-bottom: 0.2rem;
  border-radius: 0.2rem;
}
.us-priority-2{
  background-color: #67C23A;
  color: #fff !important;
  min-width: 2rem;
  text-align: center;
  padding: 0.3rem 0.5rem;
  padding-bottom: 0.2rem;
  border-radius: 0.2rem;
}
</style>
